// API layer — mock implementation for Triage board development.
// Real backend: replace each function body with an axios call.
import API from "./axios/API";

const now = Date.now();
const minsFromNow = (m) => new Date(now + m * 60_000).toISOString();

const API_BASE = `${import.meta.env.BACKEND_API}/api/support`;
// Base for the v1 workspace-scoped ticket endpoints
export const DEFAULT_WORKSPACE_ID = '69f996c4d1bb8e28e922f021';


async function apiCall(method, url, body = null) {
  const options = {
    method,
    url,
    data: body,
  };

  try {
    const response = await API(options);
    const result = response.data;

    // If the backend uses the standard ApiResponse wrapper
    if (result && typeof result === 'object' && ('success' in result || 'data' in result)) {
      if (result.success === false) {
        throw new Error(result.error || result.message || "API Error");
      }
      return result.data !== undefined ? result.data : result;
    }

    // Otherwise, assume the response body IS the data
    return result;
  } catch (err) {
    if (err.response && err.response.data) {
      const data = err.response.data;
      // Extract descriptive message from backend error response
      const errorMessage = data.message || data.error || err.message || "Request failed";
      const error = new Error(errorMessage);
      error.status = data.status || err.response.status;
      throw error;
    }
    throw err;
  }
}


let _tickets = [
  {
    _id: 'tkt-533',
    ticketNumber: '#533',
    subject: 'License renewal failed — payment declined',
    status: 'OPEN',
    priority: 'HIGH',
    category: 'License renewal / lockout',
    requesterName: 'Northwind Inc',
    requesterEmail: 'admin@northwind.com',
    requesterTier: 'NORMAL',
    assigneeId: 'agt-javed',
    assigneeName: 'Javed Mirza',
    channel: 'IN_APP',
    createdAt: new Date(now - 90 * 60_000).toISOString(),
    sla: {
      status: 'AT_RISK',
      firstResponseDeadline: minsFromNow(12),
      resolutionDeadline: minsFromNow(100),
      firstRepliedAt: null,
    },
  },
  {
    _id: 'tkt-510',
    ticketNumber: '#510',
    subject: 'Refund approval pending — finance review',
    status: 'OPEN',
    priority: 'URGENT',
    category: 'Billing / payment method',
    requesterName: 'Stark Industries',
    requesterEmail: 'tony@stark.com',
    requesterTier: 'VVIP',
    assigneeId: 'agt-zainab',
    assigneeName: 'Zainab Sheikh',
    channel: 'EMAIL',
    createdAt: new Date(now - 120 * 60_000).toISOString(),
    sla: {
      status: 'BREACHED',
      firstResponseDeadline: minsFromNow(-10),
      resolutionDeadline: minsFromNow(135),
      firstRepliedAt: null,
    },
  },
  {
    _id: 'tkt-528',
    ticketNumber: '#528',
    subject: 'TEST TICKET',
    status: 'REQUIRED_INFO',
    priority: 'LOW',
    category: 'Other',
    requesterName: 'Esme Code · CID4211',
    requesterEmail: 'esme@code.dev',
    requesterTier: 'NORMAL',
    assigneeId: 'agt-zainab',
    assigneeName: 'Zainab Sheikh',
    channel: 'IN_APP',
    createdAt: new Date(now - 200 * 60_000).toISOString(),
    sla: {
      status: 'PAUSED',
      firstResponseDeadline: minsFromNow(999),
      resolutionDeadline: minsFromNow(999),
      firstRepliedAt: new Date(now - 180 * 60_000).toISOString(),
    },
  },
  {
    _id: 'tkt-524',
    ticketNumber: '#524',
    subject: 'Need screenshots of DNS panel to proceed',
    status: 'REQUIRED_INFO',
    priority: 'MEDIUM',
    category: 'DNS / domain forwarding',
    requesterName: 'ACME Corp',
    requesterEmail: 'dns@acme.com',
    requesterTier: 'NORMAL',
    assigneeId: 'agt-javed',
    assigneeName: 'Javed Mirza',
    channel: 'IN_APP',
    createdAt: new Date(now - 300 * 60_000).toISOString(),
    sla: {
      status: 'OK',
      firstResponseDeadline: minsFromNow(860),
      resolutionDeadline: minsFromNow(1440),
      firstRepliedAt: new Date(now - 280 * 60_000).toISOString(),
    },
  },
  {
    _id: 'tkt-535',
    ticketNumber: '#535',
    subject: 'Cancel subscription — retention flow',
    status: 'IN_PROGRESS',
    priority: 'MEDIUM',
    category: 'Subscription cancellation',
    requesterName: 'Loomlane Co',
    requesterEmail: 'billing@loomlane.com',
    requesterTier: 'NORMAL',
    assigneeId: 'agt-javed',
    assigneeName: 'Javed Mirza',
    channel: 'EMAIL',
    createdAt: new Date(now - 60 * 60_000).toISOString(),
    sla: {
      status: 'OK',
      firstResponseDeadline: minsFromNow(368),
      resolutionDeadline: minsFromNow(1440),
      firstRepliedAt: new Date(now - 50 * 60_000).toISOString(),
    },
  },
  {
    _id: 'tkt-531',
    ticketNumber: '#531',
    subject: 'Migration assistance for 45 mailboxes',
    status: 'IN_PROGRESS',
    priority: 'HIGH',
    category: 'Email migration / transfer',
    requesterName: 'Wayne Enterprises',
    requesterEmail: 'it@wayne.com',
    requesterTier: 'VIP',
    assigneeId: 'agt-ejaz',
    assigneeName: 'Ejaz Shaikh',
    channel: 'IN_APP',
    createdAt: new Date(now - 30 * 60_000).toISOString(),
    sla: {
      status: 'AT_RISK',
      firstResponseDeadline: minsFromNow(25),
      resolutionDeadline: minsFromNow(1330),
      firstRepliedAt: null,
    },
  },
  {
    _id: 'tkt-512',
    ticketNumber: '#512',
    subject: 'Cannot access billing dashboard',
    status: 'RESOLVED',
    priority: 'MEDIUM',
    category: 'Billing / payment method',
    requesterName: 'Moin Shaikh · ACME',
    requesterEmail: 'moin@acme.com',
    requesterTier: 'NORMAL',
    assigneeId: null,
    assigneeName: null,
    channel: 'IN_APP',
    createdAt: new Date(now - 400 * 60_000).toISOString(),
    sla: {
      status: 'RESOLVED',
      firstResponseDeadline: minsFromNow(999),
      resolutionDeadline: minsFromNow(999),
      firstRepliedAt: new Date(now - 380 * 60_000).toISOString(),
    },
  },
  {
    _id: 'tkt-498',
    ticketNumber: '#498',
    subject: 'Migration from old Inboxlogy account',
    status: 'RESOLVED',
    priority: 'LOW',
    category: 'Email migration / transfer',
    requesterName: 'Moin Shaikh · ACME',
    requesterEmail: 'moin@acme.com',
    requesterTier: 'NORMAL',
    assigneeId: null,
    assigneeName: null,
    channel: 'IN_APP',
    createdAt: new Date(now - 500 * 60_000).toISOString(),
    sla: {
      status: 'RESOLVED',
      firstResponseDeadline: minsFromNow(999),
      resolutionDeadline: minsFromNow(999),
      firstRepliedAt: new Date(now - 480 * 60_000).toISOString(),
    },
  },
  {
    _id: 'tkt-540',
    ticketNumber: '#540',
    subject: 'Inboxlogy setup — first domain pending verification',
    status: 'NEW',
    priority: 'MEDIUM',
    category: 'Client onboarding',
    requesterName: 'Portsmith Ltd',
    requesterEmail: 'hello@portsmith.io',
    requesterTier: 'NORMAL',
    assigneeId: null,
    assigneeName: null,
    channel: 'IN_APP',
    createdAt: new Date(now - 5 * 60_000).toISOString(),
    sla: {
      status: 'OK',
      firstResponseDeadline: minsFromNow(10),
      resolutionDeadline: minsFromNow(300),
      firstRepliedAt: null,
    },
  },
];

let _customers = [
  { id: 'cust-north', name: 'Northwind Inc', email: 'admin@northwind.com', tier: 'NORMAL' },
  { id: 'cust-stark', name: 'Stark Industries', email: 'tony@stark.com', tier: 'VVIP' },
  { id: 'cust-acme', name: 'ACME Corp', email: 'admin@acme.com', tier: 'VIP' },
  { id: 'cust-wayne', name: 'Wayne Enterprises', email: 'it@wayne.com', tier: 'VIP' },
  { id: 'cust-loom', name: 'Loomlane Co', email: 'billing@loomlane.com', tier: 'NORMAL' },
  { id: 'cust-port', name: 'Portsmith Ltd', email: 'hello@portsmith.io', tier: 'NORMAL' },
];

let _idSeq = 541;

// --- Ticket statuses (in kanban column order) ---
export const TICKET_STATUSES = [
  'NEW',
  'OPEN',
  'REOPEN',
  'PENDING',
  'ESCALATED',
  'RESOLVED',
  'REQUIRE_INFO',
  'CLOSED',
];


export const TICKET_PRIORITIES = ['LOW', 'MEDIUM', 'HIGH', 'URGENT'];
export const TICKET_CHANNELS = ['IN_APP', 'EMAIL', 'SLACK', 'WHATSAPP', 'PHONE'];

// --- Ticket API ---
export const tickets = {

  /**
 * GET /api/support/{workspaceId}/export/agent-performance.xlsx
 * Downloads agent performance as an Excel file.
 * @param {string} workspaceId
 * @param {{ agentId?: string, from?: string, to?: string }} filters  - from/to as YYYY-MM-DD
 * @returns {Promise<{ blob: Blob, filename: string }>}
 */
  exportAgentPerformance: async (workspaceId = DEFAULT_WORKSPACE_ID, { agentId, from, to } = {}) => {
    const params = {};
    if (agentId) params.agentId = agentId; // omit => all agents
    if (from) params.from = from;
    if (to) params.to = to;

    try {
      const response = await API({
        method: 'GET',
        url: `${API_BASE}/${workspaceId}/export/agent-performance.xlsx`,
        params,
        responseType: 'blob',
      });

      const disposition = response.headers?.['content-disposition'] || '';
      const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition);
      const filename = match
        ? decodeURIComponent(match[1])
        : `agent-performance_${from || 'all'}_${to || 'all'}.xlsx`;

      return { blob: response.data, filename };
    } catch (err) {
      // With responseType 'blob', error bodies also arrive as a Blob, so parse them
      if (err.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          const json = JSON.parse(text);
          const error = new Error(json.message || json.error || 'Export failed');
          error.status = json.status || err.response.status;
          throw error;
        } catch (parseErr) {
          if (parseErr.message !== 'Unexpected end of JSON input' && !(parseErr instanceof SyntaxError)) throw parseErr;
        }
      }
      throw err;
    }
  },

  listTickets: async () => {
    return apiCall('GET', `${API_BASE}/${DEFAULT_WORKSPACE_ID}/tickets/list`);
  },

  getTicketDetails: async (workspaceId = DEFAULT_WORKSPACE_ID, ticketId) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/ticket/${ticketId}/details`);
  },

  getTimeZone: async (workspaceId = DEFAULT_WORKSPACE_ID, customerId) => {
    return apiCall("GET", `${API_BASE}/${workspaceId}/${customerId}/current-time`)
  },

  getBoard: async (workspaceId = DEFAULT_WORKSPACE_ID, params = {}) => {
    const {
      filter = 'ALL',
      sort = 'NEWEST_FIRST',
      search = '',
      agentId = '',
      customerId = '',
      page = 0,
      size = 20
    } = params;

    let query = `?filter=${filter}&sort=${sort}&page=${page}&size=${size}`;
    if (search) query += `&search=${encodeURIComponent(search)}`;
    if (agentId) query += `&agentId=${agentId}`;
    if (customerId) query += `&customerId=${customerId}`;

    return apiCall('GET', `${API_BASE}/${workspaceId}/board${query}`);
  },

  getCustomerTickets: async (customerId, status = 'ALL', page = 0, size = 20, sort = 'NEWEST_FIRST', search = '') => {
    let url = `${API_BASE}/${DEFAULT_WORKSPACE_ID}/tickets?page=${page}&size=${size}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (status && status !== 'ALL') {
      url += `&status=${status}`;
      url += `&filter=${status}`;
    }
    if (sort) {
      url += `&sort=${sort}`;
    }
    return apiCall('GET', url);
  },

  getCustomerCounters: async (customerId, workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/customer/${customerId}/counters`);
  },

  // For admin
  getAllCustomers: async (workspaceId = DEFAULT_WORKSPACE_ID, loginCustomerId) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/getAllCustomers?customerId=${loginCustomerId}`);
  },

  updateTicketCustomer: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('PUT', `${API_BASE}/${workspaceId}/update/customer`, data);
  },

  /**
   * PATCH /api/v1/workspace/{workspaceId}/ticket/{ticketId}/status{ticketId}/status
   * @param {string} ticketId
   * @param {string} newStatus  - e.g. 'RESOLVED'
   * @param {{ changedBy?: string, changedByName?: string, note?: string }} [meta]
   * @param {string} [workspaceId]
   */
  updateStatus: async (
    ticketId,
    status,
    { changedBy = '', changedByName = '', note = '' } = {},
    workspaceId = DEFAULT_WORKSPACE_ID
  ) => {
    let url = `${API_BASE}/${workspaceId}/ticket/${ticketId}/status`;
    url += `?newStatus=${status}`;
    url += `&changedBy=${encodeURIComponent(changedBy)}`;
    url += `&changedByName=${encodeURIComponent(changedByName)}`;
    if (note) url += `&note=${encodeURIComponent(note)}`;

    return apiCall('POST', url);
  },

  /**
   * Assign a ticket to a specific agent
   * @param {string} ticketId 
   * @param {string} agentId 
   * @param {string} workspaceId 
   */
  assignTicket: async (ticketId, agentId, workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/ticket/${ticketId}/assign?agentId=${agentId}`);
  },

  /**
   * Update support ticket assignment, category, sub-category, and notes.
   * @param {string} workspaceId
   * @param {string} ticketId
   * @param {object} request - TicketUpdateRequest payload: { issueCategoryId, issueSubCategoryId, assignedAgentId, note }
   * @param {{ changedBy?: string, changedByName?: string }} meta
   */
  updateTicketAssignment: async (
    workspaceId = DEFAULT_WORKSPACE_ID,
    ticketId,
    request,
    { changedBy = '', changedByName = '' } = {}
  ) => {
    let url = `${API_BASE}/${workspaceId}/${ticketId}/assignment`;
    url += `?changedBy=${encodeURIComponent(changedBy)}`;
    url += `&changedByName=${encodeURIComponent(changedByName)}`;

    return apiCall('PATCH', url, request);
  },

  /**
   * GET /api/support/{workspaceId}/{type}/{id}
   * Retrieves profile details for a customer or agent.
   * @param {string} type - 'CUSTOMER' or 'AGENT'
   * @param {string} id
   * @param {string} workspaceId
   */
  getProfile: async (type, id, workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/${type}/${id}`);
  },

  /**
   * POST /api/v1/workspace/{workspaceId}/support/ticket
   * User-facing ticket creation — sends the full request payload to the real backend.
   * @param {object} data  - { requesterId, subject, description, issueCategoryId, channel, orderIds?, attachments? }
   * @param {string} [workspaceId]
   */
  createTicket: async (data, workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall(
      'POST',
      `${API_BASE}/${workspaceId}/ticket/create`,
      data
    );
  },

  /**
  * POST /api/v1/workspace/{workspaceId}/support/ticket
  * User-facing ticket creation — sends the full request payload to the real backend.
  * @param {object} data  - { requesterId, subject, description, issueCategoryId, channel, orderIds?, attachments? }
  * @param {string} [workspaceId]
  */
  createWebsiteTicket: async (data, workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall(
      'POST',
      `${API_BASE}/${workspaceId}/v0/ticket/create`,
      data
    );
  },

  /**
   * Admin-only local mock — used by the triage CreateTicketDialog.
   * Keeps the board state in sync without hitting the user-facing endpoint.
   * @param {object} data - admin form fields (category, priority, requesterName, etc.)
   */
  adminCreateTicket: async (data) => {
    await delay(300);
    const ticket = {
      _id: `tkt-${_idSeq++}`,
      ticketNumber: `#${_idSeq - 1}`,
      subject: data.subject,
      status: data.status ?? 'NEW',
      priority: data.priority ?? 'MEDIUM',
      category: data.category ?? 'Other',
      subCategory: data.subCategory ?? '',
      channel: data.channel ?? 'IN_APP',
      requesterName: data.requesterName ?? 'Unknown',
      requesterEmail: data.requesterEmail ?? '',
      requesterTier: data.requesterTier ?? 'NORMAL',
      assigneeId: null,
      assigneeName: null,
      createdAt: new Date().toISOString(),
      sla: {
        status: 'OK',
        firstResponseDeadline: new Date(Date.now() + 15 * 60_000).toISOString(),
        resolutionDeadline: new Date(Date.now() + 5 * 60 * 60_000).toISOString(),
        firstRepliedAt: null,
      },
    };
    _tickets = [ticket, ..._tickets];
    return ticket;
  },

  getBoardCounters: async (workspaceId = DEFAULT_WORKSPACE_ID, agentId) => {
    let url = `${API_BASE}/${workspaceId}/board/counters`;
    if (agentId) url += `?agentId=${agentId}`;
    return apiCall('GET', url);
  },

  getMessages: async (workspaceId = DEFAULT_WORKSPACE_ID, ticketId) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/ticket/${ticketId}/messages`);
  },

  addMessage: async (workspaceId = DEFAULT_WORKSPACE_ID, ticketId, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/ticket/${ticketId}/messages`, data);
  },

  submitCsat: async (workspaceId = DEFAULT_WORKSPACE_ID, ticketId, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/ticket/${ticketId}/csat`, data);
  },

};


// --- Customer API ---
export const customers = {
  searchCustomers: async ({ query = '', limit = 20 } = {}) => {
    await delay(150);
    const q = query.toLowerCase();
    return _customers
      .filter((c) => !q || c.name.toLowerCase().includes(q) || c.email.toLowerCase().includes(q))
      .slice(0, limit);
  },
};

// --- Settings API (Taxonomy, Macros, Templates, Alerts) ---
export const settings = {
  // --- Acknowledgment Template ---
  getAckowlegment: async (workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/get/ackowlegment`);
  },

  updateAckowlegment: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('PUT', `${API_BASE}/${workspaceId}/update/ackowlegment`, data);
  },

  // --- Issue Categories ---
  listIssueCategories: async (workspaceId = DEFAULT_WORKSPACE_ID, activeOnly = true) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/issue-categories?activeOnly=${activeOnly}`);
  },

  getIssueCategoryById: async (workspaceId = DEFAULT_WORKSPACE_ID, categoryId) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/issue-categories/${categoryId}`);
  },

  createIssueCategory: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/issue-categories`, data);
  },

  updateIssueCategory: async (workspaceId = DEFAULT_WORKSPACE_ID, categoryId, data) => {
    return apiCall('PUT', `${API_BASE}/${workspaceId}/issue-categories/${categoryId}`, data);
  },

  deleteIssueCategory: async (workspaceId = DEFAULT_WORKSPACE_ID, categoryId) => {
    return apiCall('DELETE', `${API_BASE}/${workspaceId}/issue-categories/${categoryId}`);
  },

  // --- Issue Sub-Categories ---
  listSubCategories: async (workspaceId = DEFAULT_WORKSPACE_ID, issueCategoryId, activeOnly = true) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/issue-categories/${issueCategoryId}/sub-categories?activeOnly=${activeOnly}`);
  },

  createSubCategory: async (workspaceId = DEFAULT_WORKSPACE_ID, issueCategoryId, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/issue-categories/${issueCategoryId}/sub-categories`, data);
  },

  updateSubCategory: async (workspaceId = DEFAULT_WORKSPACE_ID, issueCategoryId, subCategoryId, data) => {
    return apiCall('PUT', `${API_BASE}/${workspaceId}/issue-categories/${issueCategoryId}/sub-categories/${subCategoryId}`, data);
  },

  toggleSubCategory: async (workspaceId = DEFAULT_WORKSPACE_ID, issueCategoryId, subCategoryId) => {
    return apiCall('PATCH', `${API_BASE}/${workspaceId}/issue-categories/${issueCategoryId}/sub-categories/${subCategoryId}/toggle`);
  },

  deleteSubCategory: async (workspaceId = DEFAULT_WORKSPACE_ID, issueCategoryId, subCategoryId) => {
    return apiCall('DELETE', `${API_BASE}/${workspaceId}/issue-categories/${issueCategoryId}/sub-categories/${subCategoryId}`);
  },

  listMacros: async (workspaceId = DEFAULT_WORKSPACE_ID, activeOnly = false) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/macros/list?activeOnly=${activeOnly}`);
  },

  generateMacroId: async (workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/macros/generate-id`);
  },


  getMacroById: async (workspaceId = DEFAULT_WORKSPACE_ID, macroId) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/macros/${macroId}`);
  },

  createMacro: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/macros/create`, data);
  },

  updateMacro: async (workspaceId = DEFAULT_WORKSPACE_ID, macroId, data) => {
    return apiCall('PUT', `${API_BASE}/${workspaceId}/macros/${macroId}`, data);
  },

  deleteMacro: async (workspaceId = DEFAULT_WORKSPACE_ID, macroId) => {
    return apiCall('DELETE', `${API_BASE}/${workspaceId}/macros/${macroId}`);
  },

  toggleMacro: async (workspaceId = DEFAULT_WORKSPACE_ID, macroId) => {
    return apiCall('PATCH', `${API_BASE}/${workspaceId}/macros/${macroId}/toggle`);
  },

  previewMacro: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/macros/resolve`, data);
  },

  resolveMacro: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/macros/resolve`, data);
  },

  listTemplates: async () => {
    await delay(200);
    return [
      { id: 'tmpl-ack', name: 'Auto-acknowledgement', channel: 'EMAIL', body: "Hi {{Customer Name}}, We've received your request (Ticket #{{Ticket Number}}). A {{Shift Name}} shift team member will respond...", updatedAt: new Date(now - 2 * 24 * 3600 * 1000).toISOString() },
      { id: 'tmpl-csat-f', name: 'CSAT follow-up (Negative)', channel: 'IN_APP', body: "I saw your rating on #{{N}} and want to understand what went wrong. I've escalated this to my Shift Lead...", updatedAt: new Date(now - 5 * 24 * 3600 * 1000).toISOString() },
      { id: 'tmpl-rez', name: 'Resolution notification', channel: 'EMAIL', body: "Great news! Ticket #{{N}} has been resolved. Summary of work: {{summary}}...", updatedAt: new Date(now - 12 * 24 * 3600 * 1000).toISOString() },
    ];
  },

  checkAlertPermission: async (workspaceId = DEFAULT_WORKSPACE_ID, customerId) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/alert/premission/edit?customerId=${customerId}`);
  },

  listAlerts: async (workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/alert/list`);
  },

  listAlertTiers: async (workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/alert-tiers`);
  },

  createAlertTier: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/alert-tiers`, data);
  },

  getAlertTierById: async (workspaceId = DEFAULT_WORKSPACE_ID, id) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/alert-tiers/${id}`);
  },

  toggleAlertTier: async (workspaceId = DEFAULT_WORKSPACE_ID, id) => {
    return apiCall('PATCH', `${API_BASE}/${workspaceId}/alert-tiers/${id}/toggle`);
  },

  listAlertEventTypes: async (workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/alert-event-types`);
  },

  createAlertEventType: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/alert-event-types`, data);
  },

  getAlertEventTypeById: async (workspaceId = DEFAULT_WORKSPACE_ID, id) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/alert-event-types/${id}`);
  },

  toggleAlertEventType: async (workspaceId = DEFAULT_WORKSPACE_ID, id) => {
    return apiCall('PATCH', `${API_BASE}/${workspaceId}/alert-event-types/${id}/toggle`);
  },

  createAlert: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/alert/alert/create`, data);
  },

  updateAlert: async (workspaceId = DEFAULT_WORKSPACE_ID, id, data) => {
    return apiCall('PUT', `${API_BASE}/${workspaceId}/alert/${id}`, data);
  },
  toggleAlert: async (
    workspaceId = DEFAULT_WORKSPACE_ID,
    id,
    data
  ) => {
    // send id as request parameter
    return apiCall(
      'POST',
      `${API_BASE}/${workspaceId}/alert/toggle?id=${id}`,
      data
    );
  },

  deleteAlert: async (workspaceId = DEFAULT_WORKSPACE_ID, id) => {
    return apiCall('DELETE', `${API_BASE}/${workspaceId}/alert/${id}`);
  },

  updateAlertTier: async (workspaceId = DEFAULT_WORKSPACE_ID, id, data) => {
    return apiCall('PUT', `${API_BASE}/${workspaceId}/alert-tiers/${id}`, data);
  },

  deleteAlertTier: async (workspaceId = DEFAULT_WORKSPACE_ID, id) => {
    return apiCall('DELETE', `${API_BASE}/${workspaceId}/alert-tiers/${id}`);
  },

  updateAlertEventType: async (workspaceId = DEFAULT_WORKSPACE_ID, id, data) => {
    return apiCall('PUT', `${API_BASE}/${workspaceId}/alert-event-types/${id}`, data);
  },

  deleteAlertEventType: async (workspaceId = DEFAULT_WORKSPACE_ID, id) => {
    return apiCall('DELETE', `${API_BASE}/${workspaceId}/alert-event-types/${id}`);
  },

  // --- Macro Variables ---
  listMacroVariables: async (
    workspaceId = DEFAULT_WORKSPACE_ID,
    activeOnly = true
  ) => {
    return apiCall(
      'GET',
      `${API_BASE}/${workspaceId}/macro-variables?activeOnly=${activeOnly}`
    );
  },

  getMacroVariableById: async (
    workspaceId = DEFAULT_WORKSPACE_ID,
    id
  ) => {
    return apiCall(
      'GET',
      `${API_BASE}/${workspaceId}/macro-variables/${id}`
    );
  },

  createMacroVariable: async (
    workspaceId = DEFAULT_WORKSPACE_ID,
    data
  ) => {
    return apiCall(
      'POST',
      `${API_BASE}/${workspaceId}/macro-variables`,
      data
    );
  },

  updateMacroVariable: async (
    workspaceId = DEFAULT_WORKSPACE_ID,
    id,
    data
  ) => {
    return apiCall(
      'PUT',
      `${API_BASE}/${workspaceId}/macro-variables/${id}`,
      data
    );
  },

  toggleMacroVariable: async (
    workspaceId = DEFAULT_WORKSPACE_ID,
    id
  ) => {
    return apiCall(
      'PATCH',
      `${API_BASE}/${workspaceId}/macro-variables/${id}/toggle`
    );
  },

  deleteMacroVariable: async (
    workspaceId = DEFAULT_WORKSPACE_ID,
    id
  ) => {
    return apiCall(
      'DELETE',
      `${API_BASE}/${workspaceId}/macro-variables/${id}`
    );
  },
};


// --- SLA Matrix API ---
export const slaMatrix = {
  getSLAMatrix: async (workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/matrix/list`);
  },

  initMatrix: async (workspaceId = DEFAULT_WORKSPACE_ID, changedBy) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/matrix/init?changedBy=${changedBy}`);
  },

  saveMatrix: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('PUT', `${API_BASE}/${workspaceId}/matrix/save`, data);
  },

  updateCategoryRule: async (workspaceId = DEFAULT_WORKSPACE_ID, data, changedBy, changeDescription) => {
    let url = `${API_BASE}/${workspaceId}/matrix/categories?changedBy=${changedBy}`;
    if (changeDescription) url += `&changeDescription=${encodeURIComponent(changeDescription)}`;
    return apiCall('PATCH', url, data);
  },

  toggleCategoryActive: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('PATCH', `${API_BASE}/${workspaceId}/matrix/categories/toggle`, data);
  },

  resolveTarget: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/matrix/resolve`, data);
  },

  getAuditLog: async (workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/matrix/audit-log`);
  }
};

// --- Integrations API ---
export const integrations = {
  listIntegrations: async () => {
    await delay(300);
    return [
      { id: 'int-email', type: 'EMAIL', status: 'CONNECTED', lastSyncedAt: new Date(now - 5 * 60_000).toISOString() },
      { id: 'int-chat', type: 'IN_APP', status: 'CONNECTED', lastSyncedAt: new Date(now - 2 * 60_000).toISOString() },
      { id: 'int-trust', type: 'TRUSTPILOT', status: 'CONNECTED', lastSyncedAt: new Date(now - 120 * 60_000).toISOString() },
      { id: 'int-slack', type: 'SLACK', status: 'PENDING' },
      { id: 'int-whatsapp', type: 'WHATSAPP', status: 'PENDING' },
    ];
  }
};

function delay(ms) {
  return new Promise((r) => setTimeout(r, ms));
}
// --- Knowledge Base (Articles) ---
export const kb = {
  /**
   * GET /{workspaceId}/kb/articles/filter
   * Maps to KbArticleFilterRequest – all params are optional.
   */
  /**
   * GET /{workspaceId}/article/list
   * User-facing published articles list. Always filters by PUBLISHED status.
   */
  listArticles: async (workspaceId = DEFAULT_WORKSPACE_ID, search = '') => {
    const searchParams = new URLSearchParams();
    searchParams.append('status', 'PUBLISHED');
    if (search) searchParams.append('query', search);  // backend @RequestParam is named "query"
    const url = `${API_BASE}/${workspaceId}/article/list?${searchParams.toString()}`;
    return apiCall('GET', url);
  },

  filterArticles: async (workspaceId = DEFAULT_WORKSPACE_ID, params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.search) searchParams.append('search', params.search);
    if (params.categoryId) searchParams.append('categoryId', params.categoryId);
    if (params.status) searchParams.append('status', params.status);
    if (params.author) searchParams.append('author', params.author);
    if (params.page !== undefined) searchParams.append('page', params.page);
    if (params.size !== undefined) searchParams.append('size', params.size);
    if (params.sortBy) searchParams.append('sortBy', params.sortBy);
    if (params.sortDirection) searchParams.append('sortDirection', params.sortDirection);

    const qs = searchParams.toString();
    const url = `${API_BASE}/${workspaceId}/kb/articles/filter${qs ? `?${qs}` : ''}`;
    return apiCall('GET', url);
  },

  getArticleById: async (workspaceId = DEFAULT_WORKSPACE_ID, id) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/article/${id}`);
  },

  createArticle: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/article/create`, data);
  },

  updateArticle: async (workspaceId = DEFAULT_WORKSPACE_ID, id, data) => {
    return apiCall('PUT', `${API_BASE}/${workspaceId}/article/${id}`, data);
  },

  recordView: async (workspaceId = DEFAULT_WORKSPACE_ID, id) => {
    // Controller returns noContent, so we don't use apiCall which expects result.success
    const url = `${API_BASE}/${workspaceId}/article/${id}/view`;
    return fetch(url, { method: 'POST' });
  },

  castVote: async (workspaceId = DEFAULT_WORKSPACE_ID, id, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/article/${id}/vote`, data);
  },

  deleteArticle: async (workspaceId = DEFAULT_WORKSPACE_ID, id) => {
    return apiCall('DELETE', `${API_BASE}/${workspaceId}/article/${id}`);
  },

  getKbAnalytics: async (workspaceId = DEFAULT_WORKSPACE_ID, days = 30) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/kb/analytics?days=${days}`);
  }
};

// --- KB Categories API ---
export const kbCategories = {
  listCategories: async (workspaceId = DEFAULT_WORKSPACE_ID, activeOnly = true) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/kb-categories?activeOnly=${activeOnly}`);
  },

  createCategory: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/kb-categories`, data);
  },

  updateCategory: async (workspaceId = DEFAULT_WORKSPACE_ID, id, data) => {
    return apiCall('PUT', `${API_BASE}/${workspaceId}/kb-categories/${id}`, data);
  },

  deleteCategory: async (workspaceId = DEFAULT_WORKSPACE_ID, id) => {
    return apiCall('DELETE', `${API_BASE}/${workspaceId}/kb-categories/${id}`);
  }
};

// --- Support Agents API ---
export const supportAgents = {
  listAgents: async (workspaceId = DEFAULT_WORKSPACE_ID, tier, activeOnly = true) => {
    const params = new URLSearchParams();
    if (tier) params.append('tier', tier);
    params.append('activeOnly', activeOnly);
    return apiCall('GET', `${API_BASE}/${workspaceId}/agents?${params.toString()}`);
  },

  getEligibleUsers: async (workspaceId = DEFAULT_WORKSPACE_ID) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/eligible-users`);
  },

  getAgent: async (workspaceId = DEFAULT_WORKSPACE_ID, agentId) => {
    return apiCall('GET', `${API_BASE}/${workspaceId}/agents/${agentId}`);
  },

  createAgent: async (workspaceId = DEFAULT_WORKSPACE_ID, data) => {
    return apiCall('POST', `${API_BASE}/${workspaceId}/agents`, data);
  },

  updateAgent: async (workspaceId = DEFAULT_WORKSPACE_ID, agentId, data) => {
    return apiCall('PUT', `${API_BASE}/${workspaceId}/${agentId}`, data);
  },

  toggleAgent: async (workspaceId = DEFAULT_WORKSPACE_ID, agentId, active) => {
    return apiCall('PATCH', `${API_BASE}/${workspaceId}/${agentId}/toggle?active=${active}`);
  },

  deleteAgent: async (workspaceId = DEFAULT_WORKSPACE_ID, agentId) => {
    return apiCall('DELETE', `${API_BASE}/${workspaceId}/${agentId}`);
  }
};

// --- Common / Shared API ---
export const common = {
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return API.post(
      `${import.meta.env.BACKEND_API}/uploadImages?key=${encodeURIComponent(file.name)}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }
};

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}